import React, { useEffect, useState } from "react";
import "../css/dashboard.scss";
import Header from "../components/header/Header";
import { getPartnerEpisodes } from "../services/partner";
import { useParams } from "react-router-dom";

// Episode dashboard — backed by GET /api/partner/stats/episodes?season_id=...
// Same response shape as the film/series stats endpoints (the backend
// deliberately reuses PartnerFilmStatsResponse so all three tables can share
// rendering). The legacy `.xlsx` report endpoint
// (/partner/report/episode/:id) was not ported to the Go backend and the
// download button has been removed.
const EpisodeDashboard = () => {
  const [data, setData] = useState([]);
  const { seasonId } = useParams();

  useEffect(() => {
    getPartnerEpisodes(seasonId).then((res) => {
      setData(res.data.data || []);
    });
  }, [seasonId]);

  return (
    <div className="box">
      <Header />
      <div className="filter"></div>
      <div className="all-center">
        <div className="box-table">
          <table>
            <tbody>
              <tr className="text-center">
                <th>IMAGE</th>
                <th>NAME</th>
                <th>VIEWS COUNT</th>
                <th>PRICE FOR VIEW</th>
                <th>PARTNER'S PAYMENT</th>
              </tr>

              {data.map((row) => (
                <tr key={row.content_id + row.slug}>
                  <td>
                    <img
                      width={60}
                      src={"https://media.metaflix.az/" + row.main_picture}
                      alt=""
                    />
                  </td>
                  <td>{row.name}</td>
                  <td>{row.hit}</td>
                  <td>{row.cash} AZN</td>
                  <td>{row.part} AZN</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EpisodeDashboard;
